<template>
  <div class="test-limit-popup">
    <img class="test-limit-img" src="@/assets/img/TestLimitPopupImg.jpeg"/>
        <div class="right-align">
            <v-btn @click="checkTestCount()" class="right-btn cust-btn" color="primary">OK</v-btn>
        </div>
  </div>
</template>
<script>
export default {
  name: "TestLimitPopup",
  props: ["data","onClose"],
  data() {
    return{
    }
  },
  methods:{
      checkTestCount(){
        let testLimitPopup=this.data && this.data.testCount>0 ? true:false;
        this.onClose({status:false, testLimitPopup:testLimitPopup})
      }
  }
};
</script>
<style lang="scss">

.test-limit-popup .right-align{
  position: absolute;
  width: 100%;
  bottom: 15px;
  text-align: center;
}

</style>